import React from 'react';
import { Icon, Input } from 'semantic-ui-react';
import './torre-table-ux.css';

export type TorreTableDensity = 'comfortable' | 'dense';

interface TorreTableToolbarProps {
    search: string;
    onSearchChange: (value: string) => void;
    visibleCount: number;
    totalCount: number;
    density?: TorreTableDensity;
    onDensityChange?: (density: TorreTableDensity) => void;
    showDensityToggle?: boolean;
}

const TorreTableToolbar: React.FC<TorreTableToolbarProps> = ({
    search,
    onSearchChange,
    visibleCount,
    totalCount,
    density = 'comfortable',
    onDensityChange,
    showDensityToggle = false,
}) => (
    <div className="torre-table-toolbar" data-testid="torre-table-toolbar">
        <Input
            icon="search"
            iconPosition="left"
            placeholder="Buscar placa, motorista, cliente ou rota…"
            value={search}
            onChange={(_, { value }) => onSearchChange(String(value))}
            aria-label="Busca rápida na lista"
            data-testid="torre-table-quick-search"
        />
        <span className="torre-table-toolbar-meta">
            {visibleCount === totalCount
                ? `${totalCount} viagem(ns)`
                : `${visibleCount} de ${totalCount} viagem(ns)`}
        </span>
        {showDensityToggle && onDensityChange && (
            <button
                type="button"
                className="ui mini button"
                onClick={() => onDensityChange(density === 'comfortable' ? 'dense' : 'comfortable')}
                title="Alternar densidade das linhas"
            >
                <Icon name={density === 'comfortable' ? 'compress' : 'expand'} />
                {density === 'comfortable' ? 'Compactar linhas' : 'Linhas confortáveis'}
            </button>
        )}
    </div>
);

export default TorreTableToolbar;
